































import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils/index";
import { setCount } from "@/apis/home";
import md5 from "blueimp-md5";
@Component({
  components: {},
  computed: {}
})
export default class ActivityItem extends Vue {
  @Prop({ required: true }) private item!: any;

  formatUpyunUrl = formatUpyunUrl;

  handleDetail() {
    this.$router.push(`/activity-detail?id=${this.item.activity_id}`);
  }
  async handleChat() {
    let params = {
      type: 2,
      type_id: this.item.activity_id,
      md5: md5(2 + "&" + this.item.activity_id + "&Z6pdIPQ4aFDwgxOZ")
    };
    await setCount(params);
    openJesongChat("32182", "102497");
  }
  endTime() {
    // 同一天
    if (
      this.item.start_at.substring(0, 10) == this.item.end_at.substring(0, 10)
    ) {
      return this.item.end_at.substring(11, 16);
    }
    return this.item.end_at.substring(5, 16);
  }
}
